import { render } from "./PhotoViewModal.vue?vue&type=template&id=a9ab65ac&scoped=true"
import script from "./PhotoViewModal.vue?vue&type=script&lang=js"
export * from "./PhotoViewModal.vue?vue&type=script&lang=js"

import "./PhotoViewModal.vue?vue&type=style&index=0&id=a9ab65ac&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9ab65ac"]])

export default __exports__